/**
 * Mikrofon seviye ölçer — Rapor 15 F1-32 (green room).
 *
 * ### ⭐ React state KULLANILMAZ
 * Seviye saniyede ~60 kez değişir. `useState` ile yazmak dakikada 3600 render
 * demektir; katılım ekranında bu, izin isteminden sonra gelen ilk saniyeleri
 * takılmalı gösterir. Genişlik **doğrudan DOM'a** yazılır — React ağacı hiç
 * dokunulmaz.
 *
 * ### ⚠️ `AudioContext` kullanıcı hareketi olmadan `suspended` başlar
 * Bu ölçer **yalnız** `getUserMedia` başarılı olduktan sonra kurulur; izin
 * istemi bir kullanıcı hareketiyle tetiklendiği için bağlam çalışır durumdadır.
 * Yine de `resume()` çağrılır: Safari bazı akışlarda askıda bırakır.
 *
 * ### ⚠️ Kapatma ZORUNLUDUR
 * `AudioContext` kapatılmazsa sekme başına donanım ses grafiği açık kalır;
 * Chrome birkaç bağlam sonra yenilerini reddeder ve ölçer sessizce çalışmaz.
 */

export interface MicLevelMeter {
  stop(): void;
}

export function startMicLevelMeter(track: MediaStreamTrack, bar: HTMLElement): MicLevelMeter {
  const ctx = new AudioContext();
  void ctx.resume();

  const source = ctx.createMediaStreamSource(new MediaStream([track]));
  const analyser = ctx.createAnalyser();
  // 1024 örnek ≈ 21 ms @48 kHz — göze anlık, CPU'ya ucuz.
  analyser.fftSize = 1024;
  analyser.smoothingTimeConstant = 0.6;
  source.connect(analyser);

  const buffer = new Float32Array(analyser.fftSize);
  let raf = 0;
  let stopped = false;

  const tick = (): void => {
    if (stopped) return;
    analyser.getFloatTimeDomainData(buffer);

    // RMS → yüzde. ⚠️ Tepe değeri DEĞİL: tek bir tık sesi çubuğu tavana
    //    vurdurur ve kullanıcı mikrofonunun sürekli açık olduğunu sanır.
    let sum = 0;
    for (const sample of buffer) sum += sample * sample;
    const rms = Math.sqrt(sum / buffer.length);

    // Konuşma sesi ~0.05–0.3 RMS aralığındadır; doğrusal ölçek çubuğu neredeyse
    // hiç hareket ettirmez. Kök alma algısal olarak doğru genliği verir.
    const pct = Math.min(100, Math.round(Math.sqrt(rms) * 140));
    bar.style.width = `${pct}%`;

    raf = requestAnimationFrame(tick);
  };
  raf = requestAnimationFrame(tick);

  return {
    stop(): void {
      stopped = true;
      cancelAnimationFrame(raf);
      source.disconnect();
      void ctx.close();
      bar.style.width = "0%";
    },
  };
}
